import { ScrollConfig } from '../../../models';

export const DEFAULT_SCROLL_CONFIG: ScrollConfig = {
  scrollPanelSelector: '.ebx-empathy-x__body',
  distanceToBottomInPx: 500,
  scrollEventDebounceTimeInMs: 250,
  minimumDeltaInPx: 5,
  scrollOffsetInPx: 0
};
